import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { get } from '../../../redux/api';
import { nuc } from '../../../utils';
import type { GetDependencyConfidenceResponse } from '../../../../shared/types/routes/binary';

const getRevisionDependencyConfidenceQueryKey = (
  revisionLocator: string,
): QueryKey => ['binary', revisionLocator, 'dependency-confidence'];

function getRevisionDependencyConfidence(revisionLocator: string) {
  return get<GetDependencyConfidenceResponse>(`/api/binary/${nuc(revisionLocator)}/dependency-confidence`);
}

/**
 * Helper hook for fetching the confidence of the dependencies of a user's revision.
 * @param revisionLocator - The revision locator of the user's revision.
 * @param shouldFetch - default true, allows hook to be skipped when project not available.
 * @returns A query for the confidence of the revision's dependencies.
 */
export default function useGetRevisionDependencyConfidence(
  revisionLocator: string,
  shouldFetch = true,
) {
  return useQuery<GetDependencyConfidenceResponse>({
    queryFn: () => getRevisionDependencyConfidence(revisionLocator),
    queryKey: getRevisionDependencyConfidenceQueryKey(revisionLocator),
    enabled: shouldFetch,
  });
}
